module.exports = __webpack_public_path__ + "static/media/webapp_success_check.f12f1419.svg";